module.exports = __webpack_public_path__ + "static/startup_banner_bg-f99f361bd58e85f3dc2cdceaeea4da44.png";